import { createFileRoute, redirect } from '@tanstack/react-router';

import { ChatPage } from '@/features/chat/pages/chat';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const Route = createFileRoute('/clubOwner/$id/_club/chat')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/'
      });
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  component: ChatPage
});
